import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class GenericToastrService {

  constructor(private toastr: ToastrService) { }

  public openSnackBarSuccess(message: string) {
    this.toastr.success(message, 'Succés', {
      closeButton: true,
      progressBar: true,
      timeOut: 5000,
    });
  }

  public openSnackBarProblem(message: string) {
    this.toastr.error(message, 'Erreur', {
      closeButton: true,
      progressBar: true,
      timeOut: 5000,
    });
  }
}
